export enum EventColumnTypes {
  scheduled = 0,
  upcoming ,
  completed,
  todays,
}
